export enum FontFamilyBase {
  base = 'Arial, sans-serif',
}

export enum FontFamilyEmoji {
  macOS = 'Apple color emoji',
  window = 'Segoe UI Emoji, Segoe UI Symbol',
  linux = 'Noto Color Emoji',
}
